module.exports = __webpack_public_path__ + "img/eminem-revival.d10c47e7.jpg";